/* Shared intro for florist and customer landings, including the Hub renderer. */
(() => {
  const page = document.querySelector('[data-florame-bloom-page]');
  if (!page) return;
  const heroIntro = page.querySelector('[data-fvs-bloom-intro]');
  let heroIntroFinished = !heroIntro;
  if (heroIntro) {
    const root = document.documentElement;
    const introMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const navigation = window.performance.getEntriesByType('navigation')[0];
    const shouldPlay = window.__fvsIntroEligible !== false && !window.location.hash && window.scrollY < 5 && navigation?.type !== 'back_forward' && !introMotion.matches;
    window.__fvsIntroBootCleanup?.();
    const body = document.body;
    const introScrollbar = window.__fvsIntroScrollbar ?? (innerWidth - root.clientWidth);
    const oldBody = new Map(['position', 'top', 'left', 'width'].map(key => [key, [body.style.getPropertyValue(key), body.style.getPropertyPriority(key)]]));
    let locked = false, finishTimer = 0;
    const preventScroll = event => { if (!heroIntroFinished) event.preventDefault(); };
    const finishHeroIntro = () => {
      if (heroIntroFinished) return;
      heroIntroFinished = true;
      window.clearTimeout(finishTimer);
      root.classList.remove('fvs-intro-pending');
      if (locked) oldBody.forEach(([value, priority], key) => value ? body.style.setProperty(key, value, priority) : body.style.removeProperty(key));
      page.classList.remove('is-intro-running');
      page.classList.add('is-intro-complete');
      if (heroIntro.open) heroIntro.close();
      heroIntro.remove();
      document.removeEventListener('wheel', preventScroll);
      document.removeEventListener('touchmove', preventScroll);
      window.removeEventListener('fvs:intro-abort', finishHeroIntro);
      window.removeEventListener('fvs:intro-dispose', finishHeroIntro);
      window.removeEventListener('pagehide', finishHeroIntro);
      introMotion.removeEventListener?.('change', finishHeroIntro);
      window.requestAnimationFrame(() => page.dispatchEvent(new CustomEvent('fvs:hero-intro-complete')));
    };
    if (!shouldPlay || typeof heroIntro.showModal !== 'function') {
      finishHeroIntro();
    } else {
      // The top-layer dialog covers every page band; lock the document, not the hero.
      page.classList.add('is-intro-running');
      root.classList.add('fvs-intro-pending');
      finishTimer = window.setTimeout(finishHeroIntro, 4200);
      window.addEventListener('fvs:intro-abort', finishHeroIntro);
      window.addEventListener('fvs:intro-dispose', finishHeroIntro);
      window.addEventListener('pagehide', finishHeroIntro);
      introMotion.addEventListener?.('change', finishHeroIntro);
      document.addEventListener('wheel', preventScroll, {passive: false});
      document.addEventListener('touchmove', preventScroll, {passive: false});
      body.style.setProperty('position', 'fixed');
      body.style.setProperty('top', '0');
      body.style.setProperty('left', '0');
      body.style.setProperty('width', `${innerWidth - introScrollbar}px`);
      locked = true;
      heroIntro.addEventListener('click', finishHeroIntro);
      heroIntro.addEventListener('cancel', event => { event.preventDefault(); finishHeroIntro(); });
      heroIntro.addEventListener('keydown', event => {
        if (['Escape', 'Enter', ' '].includes(event.key)) { event.preventDefault(); finishHeroIntro(); }
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) event.preventDefault();
      });
      heroIntro.addEventListener('animationend', event => { if (event.target === heroIntro && event.animationName === 'fvsBloomExit') finishHeroIntro(); });
      try {
        const sources = [heroIntro.dataset.petalOne, heroIntro.dataset.petalTwo, heroIntro.dataset.petalThree];
        const field = heroIntro.querySelector('[data-intro-petals]');
        // Deterministic arcs: small distant petals, crisp middle layer, soft close passes.
        const count = window.innerWidth < 620 ? 24 : 32;
        const spread = Math.min(window.innerWidth * .58, 700);
        for (let i = 0; i < count; i++) {
          const petal = document.createElement('img');
          const depth = i % 8 === 0 ? 'front' : i % 3 === 0 ? 'back' : 'middle';
          const side = (depth === 'front' ? i / 8 : i) % 2 ? 1 : -1, fan = .24 + ((i * 7) % 17) / 20;
          const x = side * spread * fan;
          const y = -(85 + ((i * 37) % 185)) * (window.innerHeight < 600 ? .7 : 1);
          const size = depth === 'front' ? 100 + (i % 3) * 30 : depth === 'back' ? 20 + i % 18 : 36 + i % 30;
          petal.src = sources[i % sources.length]; petal.alt = ''; petal.className = 'fvs-bloom-intro__petal'; petal.dataset.depth = depth;
          const values = {'--petal-size': `${size}px`, '--petal-x': `${x}px`, '--petal-y': `${y}px`, '--petal-fall': `${110 + i % 5 * 32}px`, '--petal-start': `${side * 25}deg`, '--petal-turn': `${side * (85 + i * 13)}deg`, '--petal-opacity': depth === 'back' ? '.35' : depth === 'front' ? '.55' : '.83', '--petal-blur': depth === 'front' ? '2.5px' : depth === 'back' ? '1px' : '0px', '--petal-delay': `${300 + i % 7 * 28}ms`, '--petal-duration': `${1900 + i % 5 * 120}ms`};
          Object.entries(values).forEach(([key, value]) => petal.style.setProperty(key, value));
          (depth === 'front' ? heroIntro : field).append(petal);
        }
        heroIntro.showModal();
        heroIntro.focus({preventScroll: true});
        const logo = heroIntro.querySelector('.fvs-bloom-intro__symbol img');
        Promise.race([logo.decode().catch(() => {}), new Promise(resolve => window.setTimeout(resolve, 350))]).then(() => {
          if (heroIntroFinished) return;
          heroIntro.classList.add('is-playing');
          window.clearTimeout(finishTimer);
          finishTimer = window.setTimeout(finishHeroIntro, 3100);
        });
      } catch (_) { finishHeroIntro(); }
    }
  } else {
    page.classList.remove('is-intro-running');
    page.classList.add('is-intro-complete');
  }

})();
